import { configureStore } from '@reduxjs/toolkit'
import rootReducer from './slices/index'

// redux-logger was imported and `createLogger()` called, but the result was
// never used — the middleware line that would consume it is commented out
// below. The dead call cost three things: it ran on every app boot for nothing,
// it produced a `'logger' is assigned a value but never used` lint warning, and
// its CommonJS/ESM interop threw "default.createLogger is not a function" under
// Vitest, which made `store` unimportable in a test.
//
// To re-enable action logging in development:
//   import reduxLogger from 'redux-logger'
//   const logger = reduxLogger.createLogger()
//   middleware: getDefaultMiddleware => getDefaultMiddleware().concat(logger)
const store = configureStore({
	reducer: rootReducer,
	middleware: getDefaultMiddleware => getDefaultMiddleware(),
})

export default store
